import {
  aEllipsisVertical,
  faPlus,
  faFileImport,
  faFileExport,
  faFileCsv,
  faUser,
  faEllipsisVertical,
  faShare,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Dropdown, Nav, Container, Table } from "react-bootstrap"
import { useLocation, useNavigate } from "react-router-dom"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import useLocalStorageState from "use-local-storage-state"
import { UpgradePlan } from "../../CommonComponents/UpgradePlan"
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler"
import DeleteModal from "../DeleteModal"
import { toast } from "sonner"
import { useEffect, useMemo, useRef, useState } from "react"
import { Pagination } from "../../CommonComponents/Pagination"
import {
  fetchTemporaryFilterData,
  formatDate,
  handleExportData,
  navigateToCrmDetail,
  sharePdf,
} from "../../Utils/helpers/commonhelper"
import { baseURL } from "../../Utils/constants/constant"
import { Filter } from "../../CommonComponents/Filter"
import { FilterPagination } from "../../CommonComponents/FIlterPagination"
import { DropdownItemWithActions } from "../../CommonComponents/DropdownItemWithActions"
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard"
import { ColumnConfigurator } from "../../CommonComponents/ColumnConfigurator"
import useCommonData from "../../Utils/actions/advanceFilteringAction"
import { ManageListDropdown } from "../../CommonComponents/ManageListDropdown"
import { TableWrapper } from "../../CommonComponents/TableWrapper"
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials"
import { useGlobalState } from "../../Utils/hooks/useFilterQueryValue"
import { FilterQueryString } from "../../CommonComponents/FilterQueryString"

export const PurchaseOrder = () => {
  // getting essentials for api fetching
  const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()
  const location = useLocation()
  const purchaseMetaData = JSON.parse(localStorage.getItem('purchaseMetaData'))
  // rbac permission object;
  const [PERMISSION, _] = useLocalStorageState('permission');

  const [currData, setCurrData] = useState(null)
  // const [currDataHeading, setCurrDataHeading] = useState("all_purchase_orders")

  const [isMyApproval, setMyApproval] = useState(() => {
    return purchaseMetaData?.isMyApproval || false
  })
  // pagination states
  // const [offset, setOffset] = useState(0)
  const [allOffset, setAllOffset] = useState(0)
  const [myApprovalOffset, setMyApprovalOffset] = useState(0)

  const activeOffset = isMyApproval ? myApprovalOffset : allOffset
  const setActiveOffset = isMyApproval ? setMyApprovalOffset : setAllOffset

  const [limit, setLimit] = useState(25)
  const [total_count, setTotalCount] = useState(0)
  const [search, setSearch] = useState("")
  const [inputSearch, setInputSearch] = useState("")
  // delete modal loading state
  const [loading, setLoading] = useState(false)

  const params = {
    limit,
    offset: activeOffset,
    search,
  }

  // states to store the filter data
  const [filterStates, setFilterState] = useState([])

  // state for heading to display
  const [heading, setHeading] = useState("All Purchase Orders")

  // loading state for temporary filter data to be hydrated
  const [tempFilterDataLoading, setTempFilterDataLoading] = useState(false)
  const [purchaseFilterDataParams, setPurchaseFilterDataParams] = useGlobalState(
    "purchaseFilterDataParams",
    { currAdvFilter: null, applyFilterData: {} }
  )

  // curr advance filter to store the current filter type between "apply" and "save as" in advance filter for respective pagination in apply filter
  const [currAdvFilter, setCurrAdvFilter] = useState(
    () => purchaseFilterDataParams?.currAdvFilter || null
  )

  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null)
  // state for filter dropdown of quotations
  const [filterDropdown, setFilterDropdown] = useState(false)

  // global value state for applying the pagination to temporary filter data
  const [purchaseFilterValues, setPurchaseFilterValues] = useGlobalState("purchaseApplyFilterQueryValues")

  // for dropdown of the filter cards being created by the user
  const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false)
  // state to store the advanced custom filter to fetch data on save
  const [customFilter, setCustomFilter] = useState(null)

  const filterCategoriesDropRef = useRef(null)

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([])
  // filter seazrch bar input state
  const [filterSearchInput, setFilterSearchInput] = useState("")
  // Add states for filter pagination and search
  const [filterOffset, setFilterOffset] = useState(0)
  const [filterLimit, setFilterLimit] = useState(5)
  const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("")
  const [filterPageCount, setFilterPageCount] = useState(0)
  // isediting state for undoing the edit state in the filter name update in the heading dropdown
  const [editingId, setEditingId] = useState(false)
  useEffect(() => {
    if (!filterSearchInput || filterSearchInput.trim() === "") {
      // If no search input, show all categories
      setFilteredCategories(filterCategories)
    } else {
      // Filter categories based on search input
      const filtered = filterCategories.filter((category) =>
        category.card_name
          .toLowerCase()
          .includes(filterSearchInput.toLowerCase())
      )
      setFilteredCategories(filtered)
    }
  }, [filterSearchInput, filterCategories])
  // fitered categories to store the search input filter categories
  const [filteredCategories, setFilteredCategories] = useState([])

  // delete modal open close state
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [po_id, setPoId] = useState("")

  // filter state to store the data to pass to delete and edit handler for filter
  const [filterData, setFilterData] = useState(null)
  // edit value state fot the filter card name edit
  const [editValue, setEditValue] = useState()
  // delete state for filter
  const [confirmFilterDelete, setFilterDelete] = useState(false)

  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false)
  const [approvalCount, setApprovalCount] = useState(0)


  useEffect(() => {
    if (!isInitialized) {
      const lastHeading = purchaseMetaData?.filterType?.filterName
      const normalizedHeading =
        lastHeading === "All Purchase Order" ? "All Purchase Orders" : lastHeading
      setHeading(normalizedHeading || "All Purchase Orders")
      setIsInitialized(true)
    }
  }, [isInitialized, purchaseMetaData])

  // Save view preference to localStorage
  useEffect(() => {
    localStorage.setItem("purchaseMetaData", JSON.stringify(
      {
        ...purchaseMetaData,
        isMyApproval: isMyApproval,
      }
    ))
  }, [isMyApproval])


  // permission setup for purchase order
  const isPurchase = PERMISSION.purchase_order?.isAuthorized;
  const purchaseGrant = PERMISSION.purchase_order;

  // common advance filter api calls that will be needed everywhere
  const { leadOwner, company, contacts } = useCommonData({
    leadOwner: true,
    leadSource: false,
    companies: true,
    contacts: true
  })

  // heading filter dropdown static options
  const purchaseStaticListOptions = [
    {
      key: "All Purchase Orders",
      icon: <FontAwesomeIcon
        icon={faUser}
        style={{ width: "13px", height: "13px", marginRight: "9px" }}
      />
    }
  ]

  const purchaseImportFields = [
    { id: "contact_name", label: "Contact Name", required: true },
    { id: "reference", label: "Reference", required: true },
    { id: "po_date", label: "Order Date", required: true },
    { id: "delivery_date", label: "Delivery Date", required: true },
    { id: "owner", label: "Owner", required: true },
    { id: "gst_no", label: "GSTN", required: false },
    { id: "description", label: "Short Description", required: true },
    { id: "product_services", label: "Product & Services", required: true },
    { id: "quantity", label: "Quantity", required: true },
    { id: "product_description", label: "Product Description", required: false },
    { id: "rate", label: "Rate", required: true },
    { id: "gst", label: "GST(%)", required: true },
    { id: "discount_type", label: "Discount Type", required: false },
    { id: "discount", label: "Discount", required: false },
    { id: "discount_amount", label: "Amount", required: true },
    { id: "sub_total", label: "Sub Total", required: true },
    { id: "grand_total", label: "Grand Total", required: true },
    { id: "special_discount", label: "Special Discount", required: false },
    { id: "special_discount_type", label: "Special Discount Type", required: false },
    { id: "special_discount_amount", label: "Special Discount Amount", required: false },
    { id: "gst_amount", label: "GST Amount", required: false },
    { id: "customer_note", label: "Customer Notes", required: false },
    { id: "terms_condition", label: "Terms & Conditions", required: false },
    { id: "billing_address", label: "Billing Address", required: false },
    { id: "billing_country", label: "Billing Country", required: false },
    { id: "billing_state", label: "Billing State", required: false },
    { id: "billing_city", label: "Billing City", required: false },
    { id: "billing_zipcode", label: "Billing Zipcode", required: false },
    { id: "shipping_address", label: "Shipping Address", required: false },
    { id: "shipping_country", label: "shipping Country", required: false },
    { id: "shipping_state", label: "shipping State", required: false },
    { id: "shipping_city", label: "shipping City", required: false },
    { id: "shipping_zipcode", label: "shipping Zipcode", required: false },
  ]
  // filter dropdown options
  const dropdownOptions = [
    { value: "reference_number", label: "Reference Number" },
    { value: "contact_id", label: "Contact", option: contacts },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "po_number", label: "Purchase Number" },
    { value: "company_id", label: "Company Name", option: company },
    { value: "delivery_date", label: "Delivery Date", type: "date-range" },
    { value: "created_at", label: "Created at", type: "date-range" },
  ]

  // sub filter dropdown option
  const subFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Not-Contains" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
    { value: "is_empty", label: "Is Empty" },
    { value: "is_not_empty", label: "Is Not Empty" },
    { value: "begins_with", label: "Begins With" },
    { value: "between", label: "Between" },
  ]
  const customSubFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "is_set", label: "Is Set" },
    { value: "is_not_set", label: "Is Not Set" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
  ]

  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim())
      setActiveOffset(0)
    }, 300)
    return () => clearTimeout(debounceTimer)
  }, [inputSearch])

  // edit handler for filter heading
  const handleFilterEdit = async () => {
    try {

      if (!editValue?.trim()) return
      if (!filterData) return

      const updatePayload = {
        customer_id: customerId,
        user_login_id: loginUserId,
        filter_id: filterData.id,
        card_name: editValue,
        description: "",
        module_name: 'purchase_order'
      }
      const res = await PutRequest(
        "common/updateFilterName",
        updatePayload,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )
      if (res?.status === "fail" || res?.success === false) {
        toast.error(res?.message || "Error Updating Filter")
        setFilterDropdown(false)
        return
      }
      setHeading(editValue.trim())
      // setIsEditing(false)
      setEditingId(null)
      setFilterDropdown(false)
      fetchFilterCardCategories()
      toast.success(res?.message)
    } catch (error) {
      toast.error("Error Updating Filter")
      return
    }
  }

  // delete handler for filter delete
  const handleFilterDelete = async () => {
    setLoading(true)
    try {
      if (filterData === null) return
      const res = await DeleteRequest(
        `common/deleteFilter/${filterData.id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )
      if (res.status === "fail") {
        toast.error(res.message)
        return
      }
      if (res.success === false) {
        toast.error(res.message)
      }
      setCustomFilter(null)
      setLoading(false)
      setFilterDropdown(false)
      setFilterDelete(false)
      setHeading("All Purchase Orders")
      filterCategories?.length !== 1 && fetchFilterCardCategories()
      filterCategories?.length === 1 && setFilterOffset(0)
      localStorage.setItem("purchaseMetaData", JSON.stringify({
        ...purchaseMetaData,
        filterType: {
          filterName: "All Purchase Orders",
          id: null
        }
      }))
      fetchPO()
      toast.success(res.message)
    } catch (error) {
      toast.error("Error Deleting Filter")
    }
  }

  // to reset the data if tempFilterData i.e if no data exist after doing apply filters in advanced searching logic
  // useEffect(() => {
  //   if (tempFilterData !== null) {
  //     setActiveOffset(0)
  //   }
  // }, [tempFilterData])

  const handleFilterPageChange = (newOffset) => {
    setFilterOffset(newOffset.selected)
  }

  const dataToDisplay =
    tempFilterData !== null ? tempFilterData.data : currData;

  const hasDataToDisplay = dataToDisplay?.length > 0;

  // state for making sure the pagination position remains updated with respect to current page items
  const currPageItems = dataToDisplay?.length;

  const isFiltered = tempFilterData !== null;
  const pageCount = Math.ceil(
    (isFiltered
      ? (tempFilterData?.total_count || 0)
      : (total_count || 0)
    ) / limit
  );

  const totalItems = isFiltered
    ? (tempFilterData?.total_count || 0)
    : (total_count || 0);

  const displayStartItem = totalItems === 0
    ? 0
    : activeOffset * limit + 1;

  const displayEndItem = totalItems === 0
    ? 0
    : Math.min(activeOffset * limit + limit, totalItems);


  // useeeffect for fetching the created advance filters
  const fetchFilterCardCategories = async () => {
    try {
      const res = await GetRequest(
        `common/fetchFilterCard/${customerId}/purchase_order/${loginUserId}?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )

      if (res.status === "fail" || res.success === false) {
        return
      }

      setFilterCategories(res.data)

      // Calculate page count if total_count is available in response
      if (res.total_count) {
        setFilterPageCount(Math.ceil(res.total_count / filterLimit))
      }
    } catch (error) {
      toast.error("Error fetching filters")
    }
  }
  useEffect(() => {
    fetchFilterCardCategories()
  }, [heading, filterOffset, filterLimit, debouncedFilterSearch])

  useEffect(() => {
    const fetchApprovalCount = async () => {
      try {
        const res = await GetRequest(
          `purchase/fetchMyApprovals/${customerId}/${loginUserId}`,
          { headers },
          extras
        )
        if (res && res.data) {
          // Assuming res.total_count exists or using array length
          const count = res.total_count || res.data.length || 0
          setApprovalCount(count)
        }
      } catch (e) {
        console.error("Error fetching approval count", e)
      }
    }
    fetchApprovalCount()
  }, [])


  const applyFilterDataParams = {
    filterValues: purchaseFilterValues,
    currView: "list",
    offset: activeOffset,
    limit: limit,
    module_name: "purchase",
    customerId: customerId,
    loginUserId: loginUserId,
    userType: userType,
    headers: headers,
    extras: extras,
    setTempFilterData: setTempFilterData,
    setLoading: setTempFilterDataLoading,
    setFilterState: setFilterState,
    setFilterDropdown: setFilterDropdown,
  }

  useEffect(() => {
    setPurchaseFilterDataParams({
      currAdvFilter: currAdvFilter,
      applyFilterData: {
        ...applyFilterDataParams,
        filterValues: purchaseFilterValues,
        currView: "list",
        offset: activeOffset,
        limit: limit,
      },
    })
  }, [currAdvFilter, purchaseFilterValues, activeOffset, limit, isMyApproval])

  useEffect(() => {
    if (
      currAdvFilter === "apply" &&
      purchaseFilterValues?.["filter_values"]?.length > 0 &&
      !isMyApproval
    ) {
      fetchTemporaryFilterData(purchaseFilterDataParams?.applyFilterData)
    }
  }, [purchaseFilterDataParams?.applyFilterData, isMyApproval])

  const { endpoint, queryKey } = useMemo(() => {
    if (currAdvFilter === "apply" && !isMyApproval) {
      return {
        endpoint: "",
        queryKey: ""
      }
    }

    // resetting state if current advance filter is null
    setPurchaseFilterValues({ filter_state: [], filter_values: [] })

    const customFilterId = purchaseMetaData?.filterType?.id
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading
    if (isMyApproval) {
      return {
        endpoint: `purchase/fetchMyApprovals/${customerId}/${loginUserId}`,
        queryKey: `fetchApprovalPurchaseOrder`
      }
    }
    if (!customFilter && !customFilterId) {
      if (lowerHeading === "all_purchase_orders") {
        return {
          endpoint: `purchase/fetchPurchaseOrder/${customerId}/${loginUserId}/${userType}`,
          queryKey: `fetchPurchaseOrders`
        }
      }
    }
    if (customFilter || customFilterId) {
      const id = customFilter?.id || customFilterId
      return {
        endpoint: `purchase/fetchPurchaseOrder/${customerId}/${loginUserId}/${userType}/${id}`,
        queryKey: `filterQuery${id}`
      }
    }
    return {
      endpoint: "",
      queryKey: ""
    }
  }, [heading, filterCategories, isMyApproval, customFilter, currAdvFilter])



  // Single useGetRequest call
  const {
    data: purchaseData,
    refetch: fetchPO,
    isLoading,
  } = useGetRequest(
    endpoint,
    queryKey,
    headers,
    { customer, setCustomer, rf: headers.Authentication, navigate },
    params
  )

  // useEffect(() => {
  //   if (endpoint && queryKey) {
  //     fetchPO();
  //   }
  // }, [isMyApproval, endpoint]);
  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {
    if (currAdvFilter === 'apply') return
    if (
      purchaseData &&
      purchaseData.filter_data &&
      purchaseData.filter_data[0] &&
      purchaseData.filter_data[0].filter_values
    ) {
      const values = purchaseData.filter_data[0].filter_values
      const parsedState = JSON.parse(values)
      const filteredArray = parsedState?.map((state) => {
        const dropdownValue = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        )

        return {
          id: state.label_name,
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownValue ? dropdownValue.label : state.label_name,
          option: dropdownValue.option,
          subFilterType: state.label_query,
          value:
            state.label_query === "between"
              ? { start: state.label_value[0], end: state.label_value[1] }
              : state.label_value,
        }
      })

      setFilterState(filteredArray)
    } else {
      setFilterState([])
    }

    setCurrData(purchaseData?.data)
    setTotalCount(purchaseData?.["total_count"])
  }, [queryKey, purchaseData, isMyApproval])

  // Function to handle navigation to detail page
  const handleNavigateToDetail = (orderId) => {
    const detailPath = isMyApproval
      ? `/purchaseDetail/${orderId}/my_approvals`
      : `/purchaseDetail/${orderId}/all_purchase_orders`;
    navigateToCrmDetail(navigate, location, detailPath);
  };

  const columnOptions = [
    { key: "po_number", label: "PO Number", mandatory: true },
    { key: "contact_full_name", label: "PO To" },
    { key: "company_name", label: "Company Name" },
    { key: "owner_full_name", label: "PO Generated By" },
    { key: "po_date", label: "Issued Date" },
    { key: "po_status", label: "Status" },
  ];

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = purchaseMetaData?.visibleColumns
    const allColumnKeys = columnOptions.map(col => col.label);
    if (saved) {
      try {
        return saved;
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });



  const handleConfirmDelete = async () => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `purchase/deletePurchaseOrder/${po_id}/${loginUserId}`,
        { headers },
        extras
      )
      if (res.status === "fail" || res.success === false) {
        return
      }
      setLoading(false)
      toast.success(res.message)
      fetchPO()
      setShowDeleteModal(false)
    } catch (error) {
      console.error("error deleting purchase order")
      return
    }
  }

  const handleSharePurchaseOrder = async (order) => {
    if (!order?.po_id) {
      toast.error("Purchase order not found!")
      return
    }

    const orderCustomerId = order?.customer_id || customerId

    await sharePdf(
      `${baseURL}purchase/downloadPO/${orderCustomerId}/${order.po_id}`,
      headers,
      "download",
      loginUserId,
      setLoading,
      `purchase_${order.po_number}`
    )
  }

  const handlePageChange = (selectedItem) => {
    setActiveOffset(selectedItem.selected)
  }

  // if module doesn't lie in the subscription plan then show upgrade modal
  if (!isPurchase) {
    return <UpgradePlan moduleName="Purchase Order" />
  }

  // if no view permission then user should see an authorization card
  if (!purchaseGrant?.isView) {
    return <div style={{ position: "absolute", left: "40%", top: "10rem" }}>
      <AuthorizationCard />
    </div>
  }

  const tableHeader = () => (<thead
    style={{
      // position: "sticky",
      top: 0,
      backgroundColor: "white",
      zIndex: 10,
    }}
  >
    <tr style={{ textAlign: "start" }}>
      <th>#</th>
      {columns.map((col, index) => (
        <th key={`header-${index}`}>{col}</th>
      ))}
      {!isMyApproval && <th key="actions-header"></th>}
    </tr>
  </thead>)

  const tableListing = () => (dataToDisplay?.map((order, index) => (
    <tr
      key={order.id}
      style={{
        marginTop: "10px",
        marginBottom: "10px",
      }}
    >
      <td>{limit * activeOffset + 1 + index}</td>

      {/* Dynamic cells based on columns order */}
      {columns.map((col, cellIndex) => {
        switch (col) {
          case "PO Number":
            return (
              <td
                key={`cell-${index}-${cellIndex}`}
                onClick={() => handleNavigateToDetail(order.id)}
                className="text-primary"
                style={{ cursor: "pointer" }}
              >
                {order?.po_number || "-"}
              </td>
            );

          case "PO To":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {order?.contact_full_name || "-"}
              </td>
            );

          case "Company Name":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {order.company_name || "-"}
              </td>
            );

          case "PO Generated By":
            return (
              <td
                key={`cell-${index}-${cellIndex}`}
                style={{
                  fontWeight: "600",
                  width: "16% auto",
                  textTransform: "capitalize",
                  backgroundColor: "white",
                }}
              >
                {order?.owner_full_name || "-"}
              </td>
            );

          case "Issued Date":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {order?.po_date
                  ? (() => {
                    const today = new Date();
                    const expiry = new Date(order?.po_date);
                    let bgColor = "";
                    if (expiry < today) bgColor = "#f8d3d5";
                    else if (expiry > today) bgColor = "#c0f7b8";
                    else bgColor = "#f9f0ce";

                    return (
                      <span
                        style={{
                          display: "inline-block",
                          backgroundColor: bgColor,
                          color: "#444040",
                          padding: "0px 6px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        {formatDate(order?.po_date)}
                      </span>
                    );
                  })()
                  : "-"}
              </td>
            );

          case "Status":
            return (
              <td
                key={`cell-${index}-${cellIndex}`}
                style={{ textTransform: "capitalize", position: "static" }}
              >
                <span
                  style={{
                    textTransform: "capitalize",
                    color:
                      order?.po_status === "pending"
                        ? "#a28414"
                        : order?.po_status === "draft"
                          ? "#1f7a96"
                          : order?.po_status === "cancel"
                            ? "#9e1920"
                            : order?.po_status === "approved"
                              ? "#239b11"
                              : order?.po_status === "reject"
                                ? "#4f575b"
                                : "#999",
                    borderRadius: "12px",
                    padding: "1.5px 6px",
                    backgroundColor:
                      order?.po_status === "pending"
                        ? "#f9f0ce"
                        : order?.po_status === "draft"
                          ? "#ceecf5"
                          : order?.po_status === "cancel"
                            ? "#f8d3d5"
                            : order?.po_status === "approved"
                              ? "#c0f7b8"
                              : order?.po_status === "reject"
                                ? "#d2d6d8"
                                : "#999",
                  }}
                >
                  {order?.po_status || "N/A"}
                </span>
              </td>
            );

          default:
            return <td key={`cell-${index}-${cellIndex}`}>-</td>;
        }
      })}

      {/* Actions column */}
      {!isMyApproval && (
        <td
          key={`actions-${index}`}
          className="lastactionTd"
          style={{
            ...styles.lastdStyle,
            position: "sticky",
            right: 0,
            backgroundColor: "white",
          }}
        >
          <div className="endTdDiv">
            <Dropdown
              as="div"
              style={{ paddingRight: "0.5rem" }}
              className="dropdownsWithoutToggle"
            >
              <Dropdown.Toggle as={Nav.Link} className="header-link">
                <FontAwesomeIcon
                  icon={faEllipsisVertical}
                  style={{
                    fontSize: "15px",
                    width: "20px",
                    color: "#536485",
                  }}
                />
              </Dropdown.Toggle>
              <Dropdown.Menu
                align={"end"}
                style={{
                  width: "8rem",
                  inset: "0px auto auto 0px",
                  boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                  position: "absolute",
                  marginTop: "-22px",
                  marginRight: "25px",
                  zIndex: "100",
                  minWidth: "3rem",
                }}
              >
                {order?.po_status !== "approved" && (
                  <>
                    <Dropdown.Item
                      style={{
                        fontSize: "12px",
                        padding: "4px 21px",
                      }}
                      className="d-flex align-items-center btn"
                      onClick={(e) => {
                        if (!purchaseGrant?.isEdit) {
                          toast.warning("You are not authorized for this action!")
                          return
                        }
                        e.stopPropagation()
                        navigate(`/createpurchaseorder/${order.id}`)
                      }}
                    >
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      style={{
                        fontSize: "12px",
                        padding: "4px 21px",
                      }}
                      className="d-flex align-items-center btn"
                      onClick={(e) => {
                        if (!purchaseGrant?.isDelete) {
                          toast.warning("You are not authorized for this action!")
                          return
                        }
                        e.stopPropagation()
                        setShowDeleteModal(true)
                        setPoId(order?.po_id)
                      }}
                    >
                      Delete
                    </Dropdown.Item>
                  </>
                )}
                <Dropdown.Item
                  style={{
                    fontSize: "12px",
                    padding: "4px 21px",
                  }}
                  className="d-flex align-items-center btn"
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (!purchaseGrant?.isExport) {
                      toast.warning("You are not authorized for this action!")
                      return
                    }
                    handleSharePurchaseOrder(order)
                  }}
                >
                  <FontAwesomeIcon
                    icon={faShare}
                    style={{
                      width: "14px",
                      height: "14px",
                      marginRight: "8px",
                      color: "#5e5f60",
                    }}
                  />
                  Share
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </td>
      )}

    </tr>
  ))
  )

  return (
    <>

      <div className="d-flex justify-content-between align-content-center px-0 w-100 py-2">
        <div className="d-flex align-items-center gap-2">
          <h3
            className="mb-0 d-flex gap-2 align-items-center"
            style={
              isMyApproval
                ? {
                  cursor: "pointer",
                  fontWeight: 300,
                  fontSize: "22px",
                  color: "rgb(154 170 183)",
                  textTransform: "capitalize"
                }
                : {
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "#4dabf4",
                  textTransform: "capitalize"
                }
            }
            onClick={() => setMyApproval(false)}
          >
            {heading}
          </h3>

          <ManageListDropdown
            heading={heading}
            setHeading={setHeading}
            categories={filterCategories}
            storageKey="purchaseMetaData"
            metadata={purchaseMetaData}
            setTempFilterData={setTempFilterData}
            onEdit={(c) => setFilterData(c)}
            onDelete={(c) => {
              setFilterData(c)
              setFilterDelete(true)
            }}
            onUpdate={(c) => {
              setFilterData(c)
              handleFilterEdit()
            }}
            staticOptions={purchaseStaticListOptions}
            filterOffset={filterOffset}
            setFilterOffset={setFilterOffset}
            handleFilterPageChange={handleFilterPageChange}
            filterPageCount={filterPageCount}
            filterLimit={filterLimit}
            editValue={editValue}
            setEditValue={setEditValue}
            editingFilterId={editingId}
            setEditingFilterId={setEditingId}
            canEdit_canDownload={true}
            setCustomFilter={setCustomFilter}
            filterQueryKey={"purchaseApplyFilterQueryValues"}
            setCurrAdvFilter={setCurrAdvFilter}
          />

          <p
            style={{ width: 1, height: 25, background: "lightblue" }}
            className="mb-0"
          ></p>
          <span
            role="button"
            tabIndex={0}
            style={
              isMyApproval
                ? {
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  cursor: "pointer",
                  color: "#4dabf4",
                }
                : {
                  cursor: "pointer",
                  fontWeight: 300,
                  color: "rgb(154 170 183)",
                }
            }
            onClick={() => setMyApproval((prev) => !prev)}
          >
            <span style={{ fontSize: "20px" }}>My Approvals</span>{" "}
            {approvalCount >= 0 && (
              <>
                {/* Notification Bell Container */}
                <div
                  className="position-relative d-inline-flex align-items-center justify-content-center"
                  style={{ cursor: "pointer" }}
                >
                  {/* The Bell Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#656565"
                    style={{ width: "20px", height: "20px" }}
                  >
                    <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
                  </svg>

                  {/* The Count Badge */}
                  {approvalCount >= 0 && (
                    <span
                      className="badge rounded-pill bg-success d-flex align-items-center justify-content-center"
                      style={{
                        position: "absolute",
                        top: "-9px",
                        right: "-7px",
                        fontSize: "7px",
                        minWidth: "16px",
                        height: "16px",
                        padding: "0 4px",
                        border: "1px solid white",
                      }}
                    >
                      {approvalCount}
                    </span>
                  )}
                </div>
              </>
            )}
          </span>

          {confirmFilterDelete && (
            <DeleteModal
              show={confirmFilterDelete}
              onClose={() => setFilterDelete(false)}
              onConfirm={() => handleFilterDelete(filterData)}
              isLoading={loading}
              message="Are you sure you want to delete this item?"
            ></DeleteModal>
          )}
        </div>
        <div
          className="d-flex align-items-center gap-1"
          style={{ height: "35px" }}
        >
          <div className="position-relative">
            <input
              type="text"
              style={{ fontSize: "12px", paddingLeft: "36px", height: "35px" }}
              className="form-control"
              placeholder="Search Here..."
              value={inputSearch}
              onChange={(e) => {
                setInputSearch(e.target.value)
                setActiveOffset(0)
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault()
                  setSearch(inputSearch)
                  setActiveOffset(0)
                }
              }}
            />
            <i
              className="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
            {inputSearch.length > 0 && (
              <i
                className="fa-solid fa-xmark"
                style={{
                  position: "absolute",
                  marginTop: "-26px",
                  zIndex: 1,
                  right: 0,
                  marginRight: "13px",
                  cursor: "pointer",
                }}
                onClick={() => setInputSearch("")}
              ></i>
            )}
          </div>
          {/* advance filtering */}
          <Filter
            canEdit_canDownload={true}
            filterDropdown={filterDropdown}
            setFilterDropdown={setFilterDropdown}
            dropdownOptions={dropdownOptions}
            filterState={filterStates}
            setFilterState={setFilterState}
            setHeading={setHeading}
            subFilter={subFilter}
            module_name={"purchase_order"}
            customSubFilter={customSubFilter}
            setTempFilterData={setTempFilterData}
            setCurrAdvFilter={setCurrAdvFilter}
            filterEndpoint={"common/filterQuery"}
            applyQuery={"purchase/applyFilter"}
            view={"list"}
            setOffset={setActiveOffset}
            setCustomFilter={setCustomFilter}
            storageKey={'purchaseMetaData'}
            metadata={purchaseMetaData}
            filterQueryKey={"purchaseApplyFilterQueryValues"}
          ></Filter>


          <ColumnConfigurator
            columnOptions={columnOptions}
            columns={columns}
            setColumns={setColumns}
            storageKey="purchaseMetaData"
            metadata={purchaseMetaData}
          />
          <Dropdown
            as="div"
            className="dropdownsWithoutToggle"
          >
            <Dropdown.Toggle as={Nav.Link} className="header-link">
              <button
                className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                style={{
                  fontSize: "1rem",
                  alignItems: "center",
                  height: "35px",
                  width: "2.5rem",
                }}
              >
                {" "}
                <FontAwesomeIcon
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                  icon={faEllipsisVertical}
                />
              </button>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="defaultDropdown dropdown-menu-end "
              style={{ width: "11rem", padding: "12px 0px", right: "3.4rem" }}
            >
              <Dropdown.Item
                onClick={() => {
                  if (!purchaseGrant?.isImport) {
                    toast.warning("You are not authorized for this action!");
                    return;
                  }
                  navigate("/importdata", {
                    state: {
                      module_name: "purchase",
                      fieldData: [
                        {
                          title: "General Fields",
                          fields: purchaseImportFields.map((c) => c),
                        },
                      ],
                    },
                  });
                }}
                href="#" className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faFileImport}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />{" "}
                Import Data
              </Dropdown.Item>
              <Dropdown.Item
                className="d-flex align-items-center"
                onClick={() => {
                  if (!purchaseGrant?.isExport) {
                    toast.warning("You are not authorized for this action")
                    return
                  }
                  handleExportData([], "purchase_order", headers, extras)
                }
                }
              >
                <FontAwesomeIcon
                  icon={faFileExport}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />{" "}
                Export Data
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Button
            type="button"
            className="btn btn-default"
            onClick={() => {
              if (!purchaseGrant?.isCreate) {
                toast.warning("You are not authorized for this action")
                return
              }
              navigate(`/createpurchaseorder/null`)
            }}
            style={{
              maxHeight: "33px",
              color: "white",
              fontSize: "14px",
              border: "1px solid",
              alignItems: "center",
              paddingRight: "10px",
              backgroundColor: "rgb(122, 58, 94)",
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Add
          </Button>
        </div>
      </div>
      {/* to show the current applied filters  */}
      <FilterQueryString
        filterValues={purchaseFilterValues?.filter_state}
        setCurrAdvFilter={setCurrAdvFilter}
        setTempFilterData={setTempFilterData}
        setFilterState={setFilterState}
        setFilterValues={setPurchaseFilterValues}
      />

      <Container
        fluid
        style={{
          fontFamily: "'Poppins', sans-serif",
          height: "calc(100vh - 10rem)",
          padding: 0,
          animation: "cardEntry 1s ease-out forwards",
        }}
        className="mt-3 p-0"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            borderRadius: "7px"
          }}
          className='position-relative container-table '
        >

          <TableWrapper
            isLoading={isLoading}
            hasData={hasDataToDisplay}
            tableHeader={tableHeader()}
            tableBody={tableListing()}
            displayStartItem={displayStartItem}
            displayEndItem={displayEndItem}
            totalItems={totalItems}
            currPageItems={currPageItems}
            offset={activeOffset}
            setOffset={setActiveOffset}
            limit={limit}
            setLimit={setLimit}
            handlePageChange={handlePageChange}
            effectivePageCount={pageCount}
            columnLabels={columns}
          />

        </div>
      </Container >
      <DeleteModal
        show={showDeleteModal}
        onClose={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        isLoading={loading}
        message="Are you sure you want to delete this item?"
      ></DeleteModal>
    </>
  )
}

const styles = {
  lastdStyle: {
    padding: "0 !important",
  },
  lastactiontd: {
    padding: "0px !important",
  },
  lastactionTh: {
    padding: "0px !important",
  },
}
